import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import Edit from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';

import { getActiveLanguageCode, translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import Pod from 'components/Pod/Pod';
import routeDefinitions from 'enum/routeDefinitions';
import { shouldShowEditButton } from 'utils/helpers';

import styles from './ProfileDetailedBio.css';


// eslint-disable-next-line complexity
function ProfileDetailedBio() {
  const {
    profileInfo: {
      countryId,
      sexPreference,
      mainLanguage,
      secondaryLanguages,
      maritalStatus,
      location,
      height,
      displayHeight,
      transType,
      transPenisSize,
      bodyDecorations,
      hairLength,
      eyeColor,
      birthdate,
    },
    performerDetails: { creationDate, lastBroadcast },
    profileName,
  } = ProfileStore;
  const { user } = UserStore;
  const showHeight = height && height !== '0,0' && height !== '0';
  const mainLanguageTranslated = mainLanguage && translate(`languages.${mainLanguage}`);
  const secondaryLanguagesTranslated =
    (secondaryLanguages && secondaryLanguages.map((sl) => translate(`languages.${sl}`)).sort()) || [];
  const profileInfoLanguagesTranslated = [mainLanguageTranslated, ...secondaryLanguagesTranslated].join(', ');
  const route = routeDefinitions.get(routeDefinitions.profileSettingsRoutes.info, { username: user.username });
  const title = shouldShowEditButton(user, profileName) ? (
    <div className={styles.flexContainer}>
      <h3 className={styles.title}>{translate('v2profile.profileInfo.detailed.bio')}</h3>
      <Link to={route}>
        <Edit className={styles.editIcon} />
      </Link>
    </div>
  ) : (
    <h3 className={styles.title}>{translate('v2profile.profileInfo.detailed.bio')}</h3>
  );
  const activeLanguageCode = getActiveLanguageCode();
  moment.locale(activeLanguageCode);
  const formattedCreationDate = moment(creationDate).format('LL');
  const formattedLastBroadcastDate = moment(lastBroadcast).format('LLL');
  const age = moment().diff(birthdate, 'years');

  return (
    <Pod titleNode={title}>
      <div className={styles.profileInfo}>
        {birthdate && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('v2profile.bio.age')}: </span>
            {age}
          </span>
        )}
        {countryId && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('v2profile.profileInfo.country')}: </span>
            {translate(`countries.${countryId}`)}
          </span>
        )}
        {sexPreference && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('profile.profile.sexPreference')}: </span>
            {translate(`profile.profile.sexPreference.${sexPreference}`)}
          </span>
        )}
        {profileInfoLanguagesTranslated && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('v2profile.profileInfo.languages')}: </span>
            {profileInfoLanguagesTranslated}
          </span>
        )}
        {maritalStatus && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('account.profileInfo.relationshipStatus')}: </span>
            {translate(`profile.profile.maritalStatus.${maritalStatus}`)}
          </span>
        )}
        {location && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('profile.profile.view.location')}: </span>
            {location}
          </span>
        )}
        {showHeight && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('account.profileInfo.height')}: </span>
            {displayHeight}
          </span>
        )}
        {transType && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('profile.profile.transType')}: </span>
            {translate(`profile.profile.transType.${transType.toLowerCase()}`)}
          </span>
        )}
        {transPenisSize && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('profile.profile.transPenisSize')}: </span>
            {translate(`profile.profile.transPenisSize.${transPenisSize.toLowerCase()}`)}
          </span>
        )}
        {bodyDecorations && bodyDecorations.length > 0 && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('account.profileInfo.bodyDecorations')}: </span>
            {bodyDecorations.map((bd) => translate(`account.profileInfo.${bd}`)).join(', ')}
          </span>
        )}
        {hairLength && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('account.profileInfo.hairLength')}: </span>
            {translate(`profile.profile.hairLength.${hairLength}`)}
          </span>
        )}
        {eyeColor && (
          <span className={`${styles.profileInfoItem} ${styles.capitalize}`}>
            <span className={styles.titleTag}>{translate('account.profileInfo.eyeColor')}: </span>
            {translate(`profile.profile.eyeColor.${eyeColor}`)}
          </span>
        )}
        {lastBroadcast && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('v2profile.profileInfo.lastBroadcast')}: </span>
            {formattedLastBroadcastDate}
          </span>
        )}
        {creationDate && (
          <span className={styles.profileInfoItem}>
            <span className={styles.titleTag}>{translate('v2profile.profileInfo.memberSince')}: </span>
            {formattedCreationDate}
          </span>
        )}
      </div>
    </Pod>
  );
}

export default observer(ProfileDetailedBio);
